import { EntityDetail } from '@/common/entityFramework/entityDetail/EntityDetail';
import { PolFormulaForm } from './PolFormulaForm';

export const PolFormulaDetail = () => {
  const tabSpecs = [{ id: 'infoTab', label: 'Info', content: <PolFormulaForm /> }];

  return <EntityDetail tabSpecs={tabSpecs} />;
};
